//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { askAuthNavigator } from '@/common/utils/getUserInfo'

export default {
    props: {
        history_lot_houses: {
            type: Array
        }
    },
    data () {
        return {
            fold: true
        }
    },
    methods: {
        toggleFold () {
            this.fold = !this.fold
        },
        goLink (e) {
            this.$router.push({
                path: e.currentTarget.dataset.href,
                force: true
            })
        }
    }
}
